import { useEffect, useState } from 'react';
import { TrendingUp, Award, Share2, Users, ChevronUp, Search } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './leaderboard.css'; // We'll define custom CSS separately
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineContentCopy } from 'react-icons/md';
import { CgArrowLongRightR } from 'react-icons/cg';
import { LiaMedalSolid } from 'react-icons/lia';
import { IoIosArrowDropright } from 'react-icons/io';
import LeaderBoardDetails from './LeaderBoardDetails';
import { toast } from 'react-toastify';
import { referralLeaderboard } from '../../actions/user';
import Pagination from '../../components/Pagination/Pagination';

const leaderboardData = [
    { id: 1, username: "CryptoKing", numOfReferral: 10,ref_id: "RF78902", points: 2450, rank: 1, avatar: "👑", trend: "up" },
    { id: 2, username: "FinanceGuru", numOfReferral: 9,ref_id: "RF23756", points: 2105, rank: 2, avatar: "🥈", trend: "up" },
    { id: 3, username: "BlockchainPro", numOfReferral: 8,ref_id: "RF45678", points: 1980, rank: 3, avatar: "🥉", trend: "down" },
    { id: 4, username: "TechTrader", numOfReferral: 7,ref_id: "RF12398", points: 1740, rank: 4, avatar: "🚀", trend: "up" },
    { id: 5, username: "InvestorElite", numOfReferral: 2,ref_id: "RF98765", points: 1520, rank: 5, avatar: "💰", trend: "up" },
    { id: 6, username: "CryptoQueen", numOfReferral: 2,ref_id: "RF24680", points: 1320, rank: 6, avatar: "✨", trend: "down" },
    { id: 7, username: "FinTechWizard", numOfReferral: 2,ref_id: "RF13579", points: 1180, rank: 7, avatar: "🧙", trend: "up" },
    { id: 8, username: "CardMaster", numOfReferral: 2,ref_id: "RF11223", points: 1050, rank: 8, avatar: "🃏", trend: "down" },
    { id: 9, username: "BitInvestor", numOfReferral: 2,ref_id: "RF99887", points: 960, rank: 9, avatar: "💎", trend: "up" },
    { id: 10, username: "WalletExpert", numOfReferral: 2,ref_id: "RF44556", points: 820, rank: 10, avatar: "🔐", trend: "down" },
];

export default function LeaderboardDesign() {
    const userDetails = useSelector((state) => state.user.user);
    const isLoggedIn = userDetails !== null && userDetails.email;
    const [leaderboardData, setLeaderboardData] = useState([]);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('all');
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [copied, setCopied] = useState(false);
    const referralCode = userDetails?.referral_code?.code;
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    const referralLink = referralCode ? `${dashboardBaseUrl}/getstarted?ref=${referralCode}` : `${dashboardBaseUrl}/getstarted`;
    const [page, setPage] = useState(1);
    const perPage = 10;
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });

    const handleCopyLink = () => {
        navigator.clipboard.writeText(referralLink);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

    const fetchLeaderboardData = async (page = 1) => {
        setLoading(true);
        // console.log(page)
        try {
            const response = await referralLeaderboard(perPage, page, searchQuery);
            const apiData = response.data || [];
            const paginationInfo = response.pagination || {};

            const transformed = apiData.map((item, index) => ({
                id: (page - 1) * perPage + index + 1,
                username: item.user.name || `User #${item.rank}`,
                numOfReferral: item.referrals,
                ref_id: item.ref_id || "—",
                points: item.points,
                rank: item.rank,
                avatar: item.rank === 1 ? "👑" : item.rank === 2 ? "🥈" : item.rank === 3 ? "🥉" : "👤",
                trend: item.trend,
                trendNav: item.trend > 0 ? "up" : item.trend < 0 ? "down" : "none",
            }));

            setLeaderboardData(transformed);
            setPagination(paginationInfo);
            setPage(page);
        } catch (error) {
            console.error('Error fetching leaderboard data:', error);
            toast.error('Failed to fetch leaderboard data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeaderboardData();
    }, []);

      
    const filteredData = leaderboardData.filter(user => 
        user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.ref_id.toLowerCase().includes(searchQuery.toLowerCase())
    );
    

  return (
    <section className="leaderboard_pg">
        <div className="leaderboard-container">
            <div className="header-gradient">
                <div className="container py-4">
                    <h1 className="display-5 fw-bold text-white mb-2">Top Participants</h1>
                    <p className="text-light">Compete, refer, and earn rewards</p>

                    {isLoggedIn && (
                        <>
                            <h6>Your referral code: <span className="text-white">{referralCode}</span></h6>

                            <div className="text-center my-1 d-flex align-items-center justify-content-start gap-3">
                                <button
                                    className="btn btn-info btn-sm share-btn"
                                    onClick={() => {
                                        if (navigator.share) {
                                        navigator.share({
                                            title: 'Join me on CardPlot!',
                                            text: 'Use my referral link to get started:',
                                            url: referralLink,
                                        }).catch((err) => {
                                            console.error('Error sharing:', err);
                                        });
                                        } else {
                                            handleCopyLink();
                                            toast.warning('Sharing is not supported on this browser. Link copied to clipboard instead!');
                                        }
                                    }}
                                    >
                                    <Share2 size={18} className="me-2" />
                                    Share Your Referral link
                                </button>
                                <div className="d-flex align-items-center gap-2">
                                    {/* <span className="mb-0">Copy</span> */}
                                    <div className="position-relative">
                                        <div className="copy-icon" title='Copy Referral Link'>
                                            <div className="position-relative">
                                                <MdOutlineContentCopy role="button" size={20} color="#fff" onClick={handleCopyLink} />
                                                {/* Tooltip */}
                                                {copied && (
                                                    <div className="copy-tooltip text-white p-2 rounded small">
                                                        Copied!
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row mt-4">
                                <div className="col-md-4 mb-3">
                                    <div className="stat-card">
                                        <div className="d-flex align-items-center mb-2">
                                            <Award className="me-2" size={20} />
                                            <h3 className="fw-semibold mb-0">Your Rank</h3>
                                        </div>
                                        <p className="fs-1 fw-bold mb-0">#{userDetails?.rank || 0}</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="stat-card">
                                        <div className="d-flex align-items-center mb-2">
                                            <TrendingUp className="me-2" size={20} />
                                            <h3 className="fw-semibold mb-0">Your Points</h3>
                                        </div>
                                        <p className="fs-1 fw-bold mb-0">{userDetails?.referral_points}</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="stat-card">
                                        <div className="d-flex align-items-center mb-2">
                                            <Users className="me-2" size={20} />
                                            <h3 className="fw-semibold mb-0">Your Referrals</h3>
                                        </div>
                                        <p className="fs-1 fw-bold mb-0">{userDetails?.referral_count}</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            
            <div className="container py-4">
                <div className="row mb-4">
                    <div className="col-md-6 mb-3 mb-md-0">
                        <div className="btn-group d-none" role="group" aria-label="Time period filters">
                            <button type="button" 
                                className={`btn ${activeTab === 'all' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                onClick={() => setActiveTab('all')}
                            >
                                All
                            </button>
                            <button type="button" 
                                className={`btn ${activeTab === 'weekly' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                onClick={() => setActiveTab('weekly')}
                            >
                                Weekly
                            </button>
                            <button type="button" 
                                className={`btn ${activeTab === 'friends' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                onClick={() => setActiveTab('friends')}
                            >
                                Friends
                            </button>
                        </div>
                    </div>
                    
                    {/* <div className="col-md-6">
                        <div className="input-group">
                            <span className="input-group-text bg-white">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search users or ref_id"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div> */}
                </div>
                
                <div className="card shadow-sm mb-4">
                    <div className="table-responsive">
                        <table className="table table-hover leaderboard-table mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center text-secondary">Rank</th>
                                    <th className='text-secondary'>User</th>
                                    <th className="text-center text-secondary">Referrals</th>
                                    <th className="text-center text-secondary">Points</th>
                                    <th className="text-center text-secondary">Ref ID</th>
                                    <th className="text-center text-secondary">Trend</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>                        
                                ) : (
                                    filteredData.map((user) => (
                                        <tr key={user.id}>
                                            <td className="text-center">
                                                {user.rank <= 3 ? (
                                                    <span className={`top-rank rank-${user.rank}`}>{user.rank}</span>
                                                ) : (
                                                    <span className="fw-semibold">#{user.rank}</span>
                                                )}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-circle me-2">
                                                        {user.avatar}
                                                    </div>
                                                    <div className="fw-medium">{user.username}</div>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <span className="ref-id">{user.numOfReferral}</span>
                                            </td>
                                            <td className="text-center text-primary fw-bold">
                                                {user.points.toLocaleString()}
                                            </td>
                                            <td className="text-center">
                                                <span className="ref-id">{user.ref_id}</span>
                                            </td>
                                            <td className="text-center">
                                                {user.trendNav === "up" ? (
                                                    <span className="trend trend-up d-inline-flex align-items-center">
                                                        <ChevronUp size={16} className="text-success" />
                                                        <span className="ms-1">+{user.trend}</span>
                                                    </span>
                                                ) : user.trendNav === "down" ? (
                                                    <span className="trend trend-down d-inline-flex align-items-center">
                                                        <ChevronUp className="trend-down-icon" size={16} />
                                                        <span className="ms-1">{user.trend}</span>
                                                    </span>
                                                ) : (
                                                    <span className="trend text-muted">{user.trend}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-end my-4 mx-2">
                        <nav>
                            <Pagination
                                currentPage={page}
                                totalPages={pagination.last_page}
                                onPageChange={(pageNum) => fetchLeaderboardData(pageNum)}
                            />
                        </nav>
                    </div>
                </div>
                
                
                <div className="reward-tiers p-4 mt-4">
                    <h2 className="fw-bold mb-4">Reward Tiers</h2>
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <div className="reward-card gold-reward">
                                <div className="d-flex flex-column justify-content-center gap-1 align-items-center mb-2">
                                    <LiaMedalSolid className="" size={30} />
                                    <h3 className="fw-bold mb-0 d-flex align-items-center">
                                        Top 3 Paticipants
                                    </h3>
                                    <span>(600 points or above)</span>
                                </div>
                                <p className="small mb-2"><IoIosArrowDropright className='mb-1' /> 1st (Rank 1) <CgArrowLongRightR size={20} /> ₦300,000</p>
                                <p className="small mb-2"><IoIosArrowDropright className='mb-1' /> 2nd (Rank 2) <CgArrowLongRightR size={20} /> ₦200,000</p>
                                <p className="small mb-1"><IoIosArrowDropright className='mb-1' /> 3rd (Rank 3) <CgArrowLongRightR size={20} /> ₦100,000</p>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="reward-card silver-reward">
                                <div className="d-flex flex-column justify-content-center gap-1 align-items-center mb-3">
                                    <LiaMedalSolid className="" size={30} />
                                    <h3 className="fw-bold mb-0">
                                        Top 4 - 15 Paticipants
                                    </h3>
                                </div>
                                <p className="mb-0"><IoIosArrowDropright className='mb-1' /> ₦50,000 each</p>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="reward-card bronze-reward">
                                <div className="d-flex flex-column justify-content-center gap-1 align-items-center mb-3">
                                    <LiaMedalSolid className="" size={30} />
                                    <h3 className="fw-bold mb-2">
                                        Reward Disbursement Condition
                                    </h3>
                                </div>
                                <p className="small mb-0">Rewards will only be distributed once the top 3 participants accumulate at least 600 points or above.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="container my-5" style={{ maxWidth: '800px' }}>
                <h2 className="fw-bold text-center mb-4">Leaderboard Reward & Referral System</h2>
                <LeaderBoardDetails />
            </section>

        </div>
    </section>
  );
}